const throwMissingParam = name => {
  throw new Error(`Missing ${name} param in selector`);
};

export const secondParam = (_first, second) => second || throwMissingParam('second');
export const thirdParam = (_first, _second, third) => third || throwMissingParam('third');
